import React, { useState, useEffect } from "react";
import Flippy, { FrontSide, BackSide } from "react-flippy";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import AudiotrackIcon from "./headphones-monochrome.png";
import PDFIcon from "./pdf_icon.jpg";
import { Skeleton } from "@material-ui/lab";
import clsx from 'clsx';

import './Story.css'

const useStyles = makeStyles((theme) => {
  return {
    date: {
      color: theme.palette.primary.main,
      position: `absolute`,
      right: 10,
      top: 10,
      borderRadius: 20,
      padding: `4px 10px`,
      background: `rgba(255,255,255,.7)`,
      fontWeight: 600,
      fontFamily: `'Open Sans', sans-serif;`,
      fontSize: 14,
      letterSpacing: `-.7px`,
      zIndex: 3,
    },
    back: {
      display: `flex`,
      flexDirection: `column`,
      backgroundColor: theme.palette.primary.main,
    },
    cardTitle: {
      fontWeight: 700,
      fontFamily: `ChaType`,
      letterSpacing: `-.8px`,
      lineHeight: 1.2,
      [theme.breakpoints.up(`xs`)]: {
        fontSize: 20,
      },
      [theme.breakpoints.up(`md`)]: {
        fontSize: 26,
      },
      [theme.breakpoints.up(`xl`)]: {
        fontSize: 32,
      },
    },
    smallTitle: {
      fontFamily: `'Open Sans', sans-serif;`,
      fontWeight: 500,
      fontSize: 18,
      lineHeight: 1.5,
      letterSpacing: `-0.5px`,
      webkitFontSmoothing: `antialiased`,
    },
    button: {
      color: `white`,
      backgroundColor: theme.palette.secondary.main,
      height: `20%`,
      marginTop: 16,
    },
  };
});


export default function Story(props) {
  const classes = useStyles();

  const { api, story, viewClicked, flip, displayOption } = props

  const [flipped, setFlipped] = useState(flip);
  const [image, setImage] = useState(``);

  const flipCard = () => {
    setFlipped(!flipped)
  };

  useEffect(() => {
    setFlipped(flip)
  }, [flip])

  const date = story.formatted_start_date

  useEffect(() => {
    if (story.image) {
      if (story.image.includes(`.mp3`)) {
        setImage(AudiotrackIcon);
      } else if (story.image.includes(`.pdf`)) {
        setImage(PDFIcon);
      } else {
        const link = api.image().imageUrl(story.image, 500, 500)
        setImage(link)
      }
    }
  }, [story.image])



  return (
    <Flippy flipDirection="horizontal" isFlipped={flipped}>
      <FrontSide onClick={flipCard}>
        {image ? (
          <img
            src={image}
            alt={story.title}
            style={{
              height: `100%`,
              width: `100%`,
              backgroundColor: `black`,
              objectFit: displayOption === `CROPPED` ? `cover` : `contain`,
            }}
          />
        ) : (
          <Skeleton variant="rect" width={210} height={118} />
        )}

        {date && <div className={classes.date}>{date}</div>}
      </FrontSide>
      <BackSide className={classes.back} onClick={flipCard}>
        <div
          style={{
            overflowY: `auto`,
            overflowWrap: `break-word`,
            padding: 5,
          }}
        >
          <div style={{ height: `80%` }}>
            <div className={clsx(classes.cardTitle, `white`)}>
              {story.title}
            </div>
            <div
              className={clsx(classes.smallTitle, `white`)}
              style={{ flexGrow: 1 }}
            >
              {story.description}
            </div>
          </div>
        </div>
        <div style={{ flexGrow: 1 }} />
        <Button
          disableRipple
          disableFocusRipple
          variant="contained"
          className={classes.button}
          onClick={viewClicked(story)}
        >
          View
        </Button>
      </BackSide>
    </Flippy>
  );
}
